import React, { Component } from 'react';
import plusWhite from '../../assets/images/plus-white.svg';
import circleGreen from '../../assets/images/circle-green.svg';
import circleRight from '../../assets/images/circle-right.svg';

export default class Half extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
    this.firstCheck = 0;
  }
  componentWillReceiveProps(nextProps) {
    if (
      this.props.itemObj &&
      nextProps.itemObj &&
      this.props.itemObj.name !== nextProps.itemObj.name
    ) {
      this.setState({ active: false });
    } else if (
      this.props.itemObj === undefined &&
      nextProps.itemObj &&
      this.firstCheck === 0
    ) {
      this.setState({ active: false });
      this.firstCheck = 1;
    }
  }
  filterIt = () => {
    this.setState({ active: true });
    this.props.clickHandler(
      this.props.myID,
      this.props.itemObj && this.props.itemObj.name ? true : false
    );
  };
  render() {
    let sectionStyle = {
      backgroundImage: `url(${this.props.itemObj && this.props.itemObj.urlS3})`,
    };
    return (
      <div className='halfDiv' onClick={this.filterIt}>
        <div
          className={
            this.props.itemObj && this.props.itemObj.name
              ? `${this.state.active} halfHalfwImage  half${this.props.currentClicked}`
              : 'test'
          }
          style={sectionStyle}
        >
          {this.props.itemObj && this.props.itemObj.name ? (
            <span>{this.props.itemObj.name}</span>
          ) : (
            <span>
              <img src={plusWhite} alt='' />
              Add
            </span>
          )}
          {this.state.active &&
          this.props.currentClicked === this.props.myID ? (
            <img src={circleGreen} alt='' />
          ) : this.props.currentClicked !== this.props.myID &&
            this.props.itemObj === undefined &&
            this.props.currentClicked !== 0 &&
            this.props.selectedHalfItems.length > 0 &&
            this.props.selectedHalfItems[this.props.myID] === undefined &&
            this.props.flag === false ? (
            <img src={circleGreen} alt='' />
          ) : this.props.itemObj && this.props.itemObj.name ? (
            <div className='faded' />
          ) : (
            <img src={circleRight} alt='' />
          )}
        </div>
      </div>
    );
  }
}
